export default __webpack_public_path__ + "static/media/cite-DCV.85bebe27.png";